import { ModalBody } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Modal, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@bonusly/design-system';

import { MeetingDTO } from '../../lib/entities/meeting';
import { useCancelMeetingModal } from './hooks/use-cancel-meeting-modal';

interface CancelMeetingModalProps {
	meeting: MeetingDTO;
	onClose: VoidFunction;
	isOpen: boolean;
	guestId: string;
}

export const CancelMeetingModal: FC<CancelMeetingModalProps> = ({ isOpen, onClose, meeting, guestId }) => {
	const { t } = useTranslation(['one_on_ones', 'common']);

	const { isSubmitting, onCancelMeeting } = useCancelMeetingModal({
		meeting,
		guestId,
		onClose,
	});

	return (
		<Modal autoFocus={false} isOpen={isOpen} onClose={onClose} scrollBehavior="outside" size="sm" isCentered>
			<ModalOverlay />

			<ModalContent aria-label={t('meeting.delete_modal.cancel', { ns: 'one_on_ones' })} tabIndex={0}>
				<Box as="form" onSubmit={onClose} aria-label={t('meeting.delete_modal.header', { ns: 'one_on_ones' })} tabIndex={0}>
					<ModalHeader>{t('meeting.delete_modal.header', { ns: 'one_on_ones' })}</ModalHeader>
					<ModalCloseButton size="lg" borderRadius="full" />

					<ModalBody px={5} pb={0}>
						{t('meeting.delete_modal.content', {
							ns: 'one_on_ones',
						})}
					</ModalBody>

					<ModalFooter p={5} justifyContent="space-between">
						<Button color="primary.fg" mr={3} isActive={isSubmitting} onClick={onClose} variant="ghost">
							{t('cancel', { ns: 'common' })}
						</Button>

						<Button colorScheme="primary" isLoading={isSubmitting} onClick={onCancelMeeting}>
							{t('meeting.delete_modal.cancel', { ns: 'one_on_ones' })}
						</Button>
					</ModalFooter>
				</Box>
			</ModalContent>
		</Modal>
	);
};
